import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactMethods = () => {
  const contactMethods = [
    {
      id: 1,
      title: "Membership Inquiries",
      description: "Ready to join our community of young leaders?",
      phone: "+94 77 123 4567",
      email: "membership@leoclubcolombo.lk",
      icon: "UserPlus",
      color: "bg-primary",
      hours: "Mon-Fri: 9AM-6PM"
    },
    {
      id: 2,
      title: "Project Partnerships",
      description: "Collaborate with us on community service projects",
      phone: "+94 77 234 5678",
      email: "projects@leoclubcolombo.lk",
      icon: "Handshake",
      color: "bg-secondary",
      hours: "Mon-Fri: 10AM-5PM"
    },
    {
      id: 3,
      title: "General Information",
      description: "Questions about our activities and impact?",
      phone: "+94 77 345 6789",
      email: "info@leoclubcolombo.lk",
      icon: "Info",
      color: "bg-accent",
      hours: "Mon-Sat: 8AM-7PM"
    },
    {
      id: 4,
      title: "Corporate Partnerships",
      description: "Explore sponsorship and collaboration opportunities",
      phone: "+94 77 456 7890",
      email: "partnerships@leoclubcolombo.lk",
      icon: "Building2",
      color: "bg-warning",
      hours: "Mon-Fri: 9AM-5PM"
    }
  ];

  const handleCall = (phone) => {
    window.open(`tel:${phone}`, '_self');
  };

  const handleEmail = (email) => {
    window.open(`mailto:${email}`, '_blank');
  };

  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Get In Touch
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Choose the best way to connect with us based on your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {contactMethods.map((method) => (
            <div
              key={method.id}
              className="bg-card rounded-xl p-8 card-shadow hover:card-shadow-hover transition-smooth"
            >
              <div className="flex items-start gap-4">
                <div className={`${method.color} w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0`}>
                  <Icon name={method.icon} size={24} className="text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-card-foreground mb-2">
                    {method.title}
                  </h3>
                  <p className="text-muted-foreground mb-4">
                    {method.description}
                  </p>
                  
                  <div className="space-y-3">
                    <div className="flex items-center gap-3">
                      <Icon name="Phone" size={18} className="text-primary" />
                      <button
                        onClick={() => handleCall(method.phone)}
                        className="text-foreground hover:text-primary transition-smooth font-medium"
                      >
                        {method.phone}
                      </button>
                    </div>
                    
                    <div className="flex items-center gap-3">
                      <Icon name="Mail" size={18} className="text-primary" />
                      <button
                        onClick={() => handleEmail(method.email)}
                        className="text-foreground hover:text-primary transition-smooth font-medium break-all"
                      >
                        {method.email}
                      </button>
                    </div>
                    
                    <div className="flex items-center gap-3">
                      <Icon name="Clock" size={18} className="text-muted-foreground" />
                      <span className="text-sm text-muted-foreground">
                        {method.hours}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-card rounded-xl p-8 card-shadow">
            <div className="flex items-center justify-center w-16 h-16 bg-error/10 rounded-full mx-auto mb-4">
              <Icon name="AlertTriangle" size={24} className="text-error" />
            </div>
            <h3 className="text-xl font-semibold text-card-foreground mb-2">
              Emergency Contact
            </h3>
            <p className="text-muted-foreground mb-4">
              For urgent community service needs or crisis response situations
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                variant="destructive"
                iconName="Phone"
                iconPosition="left"
                onClick={() => handleCall('+94 77 999 8888')}
              >
                +94 77 999 8888
              </Button>
              <Button
                variant="outline"
                iconName="Mail"
                iconPosition="left"
                onClick={() => handleEmail('emergency@leoclubcolombo.lk')}
              >
                emergency@leoclubcolombo.lk
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;